const DEMO_LESSON = '/d-lesson/'

export const DEMO_LESSON_EVALUATION = `${DEMO_LESSON}evaluation/` as const
export const DEMO_LESSON_EVALUATION_PRINCIPAL = `${DEMO_LESSON_EVALUATION}principal` as const
export const DEMO_LESSON_EVALUATION_CATEGORY = `${DEMO_LESSON_EVALUATION}category/` as const
export const DEMO_LESSON_EVALUATION_ASSIGNED = `${DEMO_LESSON_EVALUATION}evaluator-assign/assigned` as const
export const DEMO_LESSON_EVALUATION_REPORT = `${DEMO_LESSON_EVALUATION}report/` as const

export const DEMO_LESSON_EVALUATION_RESPONSE = `${DEMO_LESSON_EVALUATION}response/` as const
export const DEMO_LESSON_EVALUATION_RESPONSE_ALL = `${DEMO_LESSON_EVALUATION}response/all` as const

export const DEMO_LESSON_COURSE = `${DEMO_LESSON}course/` as const
export const DEMO_LESSON_COURSE_ALL = `${DEMO_LESSON_COURSE}all` as const

export const DEMO_LESSON_MODULE = `${DEMO_LESSON}module/` as const
export const DEMO_LESSON_MODULE_ALL = `${DEMO_LESSON_MODULE}all` as const
